import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import {
  setWorkflowAction,
  setWorkflowIndex,
} from "../../../../store/userSlice";
import OPS1_EMPLOYEE_DETAILS from "../WorkFlowDependentAddition/OPS1/OPS1_EMPLOYEE_DETAILS";
import { GoEye } from "react-icons/go";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function OPS1_InsuranceDependent({
  titles = [],
  list = [],
  updateData,
  data,
  action,
  setAction,
}) {
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/downloadDependentSummary`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DependentSummary`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const token = localStorage.getItem("nodeToken");
  const uploadFile = async (file) => {
    console.log(file, "Data to be capctured here in log.......");
    if (file) {
      setLoading((p) => ({ ...p, loadingId: file }));
      try {
        const response = await nodeinstance.get(
          `/insurance-dependent/dependentDetails/${file.Employee_unique_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          // apiCall()
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
        console.log(response.data);
        setItem(response.data.data);
        setAction(true);
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const dispatch = useDispatch();
  const [item, setItem] = useState();

  const [searchWords, setSearchWords] = React.useState([]);

  return (
    <div>
      {action === false ? (
        <>
          <div className="flex gap-x-4 mt-4">
            <Search
              searchKey={[
                "employee_id",
                "passport_number",
                "iqama_number",
                "client_id",
                "emp_id",
                "sponsor_id",
              ]}
              setSearchWords={setSearchWords}
            />
            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
              onClick={() => downloadFile()}
            >
              DOWNLOAD
            </button>
            <input type="date" className="px-4 rounded-md " />
          </div>

          <div
            className={`grid grid-cols-table-workflow-ops1 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md mt-10`}
          >
            {/* <button onClick={clickHandeler}>ACTION</button> */}
            {titles.map((t, index) => (
              <p key={index} className="font-semibold uppercase">
                {t}
              </p>
            ))}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {!list?.isLoading && <NoDataFound />}

            {!list?.isLoading
              ? currentList?.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.request_type || "-"}
                      />
                    </p>
                    <p>
                      {/* <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.no_of_dependents || "-"}
                  /> */}
                      {list.no_of_dependents}
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.emp_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.gender || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.nationality || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.actual_profession || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client_name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_expiry_date_g || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.project || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.insurance_class || "-"}
                      />
                    </p>
                    <div
                      className="ml-2 cursor-pointer"
                      onClick={() => uploadFile(list)}
                    >
                      <GoEye fontSize={22} className="ml-2" />
                    </div>

                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))
              : ""}
          </div>

          <Pagination />
        </>
      ) : (
        <>
          <OPS1_EMPLOYEE_DETAILS
            details={[
              "EMPLOYEE NAME",
              "DOB",
              "KSA ARRIVAL DATE",
              "NATIONALITY",
              "IQAMA NUMBER",
              "PASSPORT NUMBER",
              "CLIENT NAME",
              "TOTAL SALARY",
            ]}
            data={item}
            setAction={setAction}
          />
        </>
      )}
    </div>
  );
}
